import { render, staticRenderFns } from "./jumpPage.vue?vue&type=template&id=8cac433a&"
import script from "./jumpPage.vue?vue&type=script&lang=js&"
export * from "./jumpPage.vue?vue&type=script&lang=js&"
import style0 from "./jumpPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports